module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_7016.bcba6f69.png";